import * as tslib_1 from "tslib";
import keyCodes from "../../../consts/keyCodes";
import cx from 'classnames';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

var Checkable =
/** @class */
function (_super) {
  tslib_1.__extends(Checkable, _super);

  function Checkable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleClick = function (event) {
      var _a = _this.props,
          checked = _a.checked,
          disabled = _a.disabled,
          shouldPropagate = _a.shouldPropagate,
          onChange = _a.onChange;

      if (!shouldPropagate) {
        event.stopPropagation();
      }

      if (disabled) {
        return;
      }

      onChange(!checked, event);
    };

    _this.handleKeyDown = function (event) {
      var key = event.which.toString();

      if (key === keyCodes.space || key === keyCodes.enter) {
        _this.handleClick(event);
      }
    };

    return _this;
  }

  Checkable.prototype.render = function () {
    var _a;

    var _b = this.props,
        blockClassName = _b.blockClassName,
        type = _b.type,
        checked = _b.checked,
        disabled = _b.disabled,
        className = _b.className,
        children = _b.children;
    var finalClassName = cx(blockClassName, (_a = {}, _a[blockClassName + "--active"] = checked, _a[blockClassName + "--disabled"] = disabled, _a), className);
    var checkableControl = React.cloneElement(children, {
      onClick: this.handleClick
    });
    return React.createElement("div", {
      className: finalClassName,
      onKeyDown: this.handleKeyDown
    }, React.createElement("input", {
      type: type,
      className: "nx-checkable__input",
      disabled: disabled,
      checked: checked,
      readOnly: true
    }), checkableControl);
  };

  Checkable.propTypes = {
    type: PropTypes.oneOf(['checkbox', 'radio']),
    blockClassName: PropTypes.string.isRequired,
    className: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    shouldPropagate: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node
  };
  Checkable.defaultProps = {
    type: 'checkbox',
    checked: false,
    disabled: false,
    shouldPropagate: false,
    onChange: noop
  };
  return Checkable;
}(Component);

export default Checkable;

try {
  // @ts-ignore
  Checkable.__docgenInfo = {
    "description": "",
    "displayName": "Checkable",
    "props": {
      "blockClassName": {
        "defaultValue": null,
        "description": "",
        "name": "blockClassName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "type": {
        "defaultValue": {
          value: "checkbox"
        },
        "description": "",
        "name": "type",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "checked": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "checked",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "disabled": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "disabled",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "shouldPropagate": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "shouldPropagate",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "onChange": {
        "defaultValue": null,
        "description": "",
        "name": "onChange",
        "required": true,
        "type": {
          "name": "(checked: boolean, event: SyntheticEvent<Element>) => void"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}